import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { getToken, removeToken } from '@/utils/auth'
import qs from 'qs'

const service = axios.create({
  baseURL: process.env.BASE_API, 
  timeout: 60000 
})

service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['X-CSRF-Token'] = getToken()
      config.headers['Content-Type'] = 'application/json'
    }
    return config
  },
  error => {
    // 处理请求错误
    console.log(error)
    Promise.reject(error)
  }
)

export const formDataService = axios.create({
  baseURL: process.env.BASE_API, 
  timeout: 60000
})

formDataService.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['X-CSRF-Token'] = getToken()
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    return config
  },
  error => {
    // 处理请求错误
    console.log(error)
    Promise.reject(error)
  }
)

let message = ''
// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 0 || res.code === '0') {
        // 可以在这里统一处理响应错误
        message && message.close()
        message = Message({
          type: 'error',
          message: res.msg || "出现错误，请稍后再试"
        });
        return Promise.reject(res);
    }else if(res.code == 101){
      MessageBox.alert('登陆验证失效，请重新登录', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        store.dispatch('FedLogOut').then(() => {
          location.reload()
        })
      })
      removeToken() // 清除cookies
      return Promise.reject('error')
    }else if(res.code == 103){
      MessageBox.alert('无权限，请联系管理员', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
         
      })
      return Promise.reject('error')
    }else if(res.code == 105) {
      MessageBox.alert(res.msg, '提示', {
        confirmButtonText: '关闭',
        type: 'warning'
      }).then(() => {
         
      })
      return Promise.reject('error')
    }else{
      return response.data
    }
  }, error => {
    console.error('请求失败' + error)//debug
    message && message.close()
    message = Message({
      message: '登录连接超时,请联系管理员',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js